import { render, staticRenderFns } from "./CoverMyMedsButtonsComponent.vue?vue&type=template&id=6ae8ee1c&scoped=true"
import script from "./CoverMyMedsButtonsComponent.vue?vue&type=script&lang=ts"
export * from "./CoverMyMedsButtonsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae8ee1c",
  null
  
)

export default component.exports